exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.numLikesStyle[data-v-01ea82c0]{background-color:white;opacity:1;cursor:default\n}\n", ""]);

// exports
